
const API = (source = 'redshift') => {
    const SOURCES = ['redshift','live','jira','test']

    if(!SOURCES.includes(source)){
        throw "API source invalid: " + source + ". Allowed ones: " + SOURCES.join(', ')
    }

    const health = async () => {
        const health = await fetch('/api/health');
        return health
    }

    const getUser = async () => {
        const response = await fetch('/api/user');
        let result;
        if(response.ok) {
            try {
                result = await response.json()
            }catch (e){
                result = {error: e.toString()}
            }
        } else {
            result = {error:response.status}
        }
        return result
    }

    const runNamedQuery = async (queryName, params) => {
        const URL = '/api/' + source + '/' + queryName + "?" + new URLSearchParams(params)
        const response = await fetch(URL);
        let result;
        if(response.ok) {
            try {
                result = await response.json()
                if(result.data)
                    result = convertDates(result)
            }catch (e){
                result = {error: e.toString()}
            }
        } else {
            result = {error:response.status}
        }
        return result
    }

    const getNamedQueryMeta = async (queryName) => {
        const URL = '/api/' + source + '/meta/' + queryName
        const response = await fetch(URL);
        let result;
        if(response.ok) {
            try {
                result = await response.json()
            }catch (e){
                result = {error: e.toString()}
            }
        } else {
            result = {error:response.status}
        }
        return result
    }

    const getNamedQuerySql = async (queryName) => {
        const URL = '/api/queries/sql/' + queryName
        const response = await fetch(URL);
        let result;
        if(response.ok) {
            try {
                result = await response.json()
            }catch (e){
                result = {error: e.toString()}
            }
        } else {
            result = {error:response.status}
        }
        return result
    }

    const allowPublicAccessToQuery = async (queryName) => {
        const URL = '/api/public-access/' + queryName
        const response = await fetch(URL);
        let result;
        if(response.ok) {
            try {
                result = await response.text()
            }catch (e){
                result = {error: e.toString()}
            }
        } else {
            result = {error:response.status}
        }
        return result
    }

    const getMyPublicAccessTokens = async (query_name = "") => {
        const URL = '/api/public-access?' + new URLSearchParams({query_name:query_name})
        const response = await fetch(URL);
        let result;
        if(response.ok) {
            try {
                result = await response.json()
            }catch (e){
                result = {error: e.toString()}
            }
        } else {
            result = {error:response.status}
        }
        return result
    }

    const getQueryPublicUrl = (authToken, format, queryName, params) => {
        return window.location.origin + '/api/public/' + authToken + '/' + format + '/' + queryName + "?" + new URLSearchParams(params)
    }

    const convertDates = (feed) => {
        const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/;
        const data = feed.data.map( row => row.map(
            cell => {

                if (typeof cell === "string" && dateFormat.test(cell)) {
                    const utc_date = (cell.slice(-1) === "Z") ? cell : cell + "Z" // UTC enforcement
                    return new Date(Date.parse(utc_date));
                } else {
                    return cell
                }
            }
        ))
        feed.data = data
        return feed
    }

    return {
        health                  : health,
        getUser                 : getUser,
        runNamedQuery           : runNamedQuery,
        getNamedQueryMeta       : getNamedQueryMeta,
        getNamedQuerySql        : getNamedQuerySql,
        getQueryPublicUrl       : getQueryPublicUrl,
        allowPublicAccessToQuery: allowPublicAccessToQuery,
        getMyPublicAccessTokens : getMyPublicAccessTokens
    }
}

export default API